import http from '../http'
import * as types from '../mutation-types';

// state
export const state = {
    status: '',
    token: localStorage.getItem('token') || '',
    user : {}
};

// getters
export const getters = {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    user: state => state.user
};

// mutations
export const mutations = {
    [types.AUTH_STATUS_LOADING](state) {
        state.status = 'loading'
    },
    [types.AUTH_STATUS_SUCCESS](state, token) {
        state.status = 'success'
        state.token = token
        http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
    [types.AUTH_STATUS_ERROR](state) {
        state.status = 'error'
    },
    [types.AUTH_LOGOUT](state) {
        state.status = ''
        state.token = ''
    },
    [types.SHOW_ME_SUCCESS](state, user) {
        state.user = user
    },
    [types.SHOW_ME_ERROR](state) {
        state.user = ''
    },
};

// actions
export const actions = {
    login({commit}, user){
        return new Promise((resolve, reject) => {
            commit(types.AUTH_STATUS_LOADING)
            http.post('/auth/login', user).then(({data: {data}}) => {
                const token = data.access_token
                localStorage.setItem('token', token)
                commit(types.AUTH_STATUS_SUCCESS, token)
                actions.me({commit});
                resolve(data)
            }).catch(({response}) => {
                commit(types.AUTH_STATUS_ERROR)
                localStorage.removeItem('token')
                reject(response.data)
            })

        })
    },
    me({commit}) {
        return new Promise((resolve, reject) => {
            commit(types.AUTH_STATUS_LOADING)
            http.get('/auth/me').then(({data: {data}}) => {
                commit(types.SHOW_ME_SUCCESS, data)
                resolve(data)
            }).catch(({response}) => {
                commit(types.SHOW_ME_ERROR)
                localStorage.removeItem('token')
                reject(response.data)
            })
        })
    },
    logout({commit}){
        return new Promise((resolve, reject) => {
            commit(types.AUTH_LOGOUT)
            localStorage.removeItem('token')
            delete http.defaults.headers.common['Authorization']
            resolve()
        })
    }
};
